var map = {
	"./all-corners-rounded-3.webp": 296,
	"./all-corners-rounded.webp": 297,
	"./all-top-corners-rounded-3.webp": 298,
	"./all-top-corners-rounded.webp": 299,
	"./circle.webp": 300,
	"./custom.webp": 301,
	"./outer-bottom-corners-rounded-3.webp": 302,
	"./outer-bottom-corners-rounded.webp": 303,
	"./outer-corners-rounded-3.webp": 304,
	"./outer-corners-rounded.webp": 305,
	"./outer-top-corners-rounded-3.webp": 306,
	"./outer-top-corners-rounded.webp": 307,
	"./rectangle-1-break.webp": 308,
	"./rectangle-2-breaks.webp": 309,
	"./rectangle-3-breaks.webp": 310,
	"./rounded-back.webp": 311,
	"./rounded-bottom-2.webp": 312,
	"./rounded-bottom-3.webp": 313,
	"./rounded-bottom.webp": 314,
	"./rounded-corners.webp": 315,
	"./rounded-front.webp": 316,
	"./rounded-rectangle-1-break.webp": 317,
	"./rounded-rectangle-2-breaks.webp": 318,
	"./rounded-rectangle-3-breaks.webp": 319,
	"./rounded-top.webp": 320,
	"./squared-corners-2.webp": 321,
	"./squared-corners-3.webp": 322,
	"./squared-corners.webp": 323,
	"./trapezoid.webp": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 295;